import { useQueryClient } from '@tanstack/react-query';
import { useState, useMemo } from 'react'
import SOURCES from '../../../../utils/constants';
import useDebounce from '../../../../utils/customHooks';
import { useLocation, useHistory } from 'react-router-dom';
import CommonCard from '../../../global/card';
import { useGenericQuery } from '../../../../queries/use-generic-query';
import { QUERY_KEYS } from '../../../../lib/query-constants';
import EnhancedHotLeadsList from './EnhancedHotLeadsList';
import CommonPagination from '../../../global/pagination';
import CommonSkeletonLoader from '../../../global/loading';

const EnhancedHotLeads = () => {
    const [searchLeadsImportedViaForm, setSearchLeadsImportedViaForm] = useState("");

    const location = useLocation();
    const history = useHistory();
    const searchParams = new URLSearchParams(location.search);
    const pageFromQuery = parseInt(searchParams.get("page") || 1, 10);
    const limitFromQuery = parseInt(
        searchParams.get("limit") || SOURCES.DEFAULT_RECORDS_LISTING,
        10
    );
    const offsetFromQuery = parseInt(searchParams.get("offset") || "0", 10);
    const [pagination, setPagination] = useState({
        offset: offsetFromQuery,
        limit: limitFromQuery,
        page: pageFromQuery,
    });

    const [sort, setSort] = useState({ sortType: "", sortOrder: 1 });
    const [hotLeadsViewType, setHotLeadsViewType] = useState(() => {
        return localStorage.getItem("hotLeadsViewType") || "GRID";
    });
    const debouncedSearchTerm = useDebounce(searchLeadsImportedViaForm, 500);


    const keyParams = useMemo(() => ({
        offset: pagination.offset,
        limit: pagination.limit,
        sortBy: sort.sortType,
        sortOrder: sort.sortOrder,
    }), [pagination.offset, pagination.limit, sort.sortType, sort.sortOrder]);

    const { data: hotLeadsData, isLoading: hotLeadsLoading } = useGenericQuery({
        endpoint: "leadinfo/hotlead",
        queryKey: QUERY_KEYS.hotLeads.lists({ ...keyParams }),
        queryParams: { ...keyParams },
        onError: () => { },
        onSuccess: () => { },
    })

    const { data: searchData, isInitialLoading: searchDataLoading } = useGenericQuery({
        endpoint: "leadinfo/hotlead-search",
        queryKey: QUERY_KEYS.hotLeads.lists({ q: debouncedSearchTerm }),
        queryParams: { q: debouncedSearchTerm },
        enabled: !!debouncedSearchTerm
    })

    const finalData = useMemo(() => {
        if (debouncedSearchTerm && searchData) {
            return searchData?.results || [];
        }
        return hotLeadsData?.results || [];
    }, [debouncedSearchTerm, searchData, hotLeadsData]);

    const dataExist = finalData.length > 0;
    const isLoading = hotLeadsLoading || searchDataLoading;

    const handleViewTypeChange = (type) => {
        setHotLeadsViewType(type);
        localStorage.setItem("hotLeadsViewType", type);
    };

    return (
        <CommonCard
            isLoading={{
                show: isLoading,
                loaderCmp: <CommonSkeletonLoader
                    type={hotLeadsViewType === "GRID" ? "card" : "table"}
                />
            }}
            isSearch={{
                searchInput: searchLeadsImportedViaForm,
                setSearchInput: setSearchLeadsImportedViaForm,
                placeholder: "Hot leads search...",
                show: true
            }}
            isListGridView={{
                viewType: hotLeadsViewType,
                setViewType: handleViewTypeChange,
                show: true,
                viewFor: "hotLeadsViewType"
            }}
        >
            <EnhancedHotLeadsList
                isLoading={isLoading}
                hotLeads={finalData}
                sort={sort}
                setSort={setSort}
                viewType={hotLeadsViewType}
                keyParams={keyParams}
            />

            {(dataExist && !debouncedSearchTerm) &&
                <CommonPagination
                    currentPage={pagination.page}
                    defaultLimit={pagination.limit}
                    totalRecords={hotLeadsData?.totalReords || 0}
                    setCurrentPage={setPagination}
                    activePageRecords={finalData.length}
                    paginationFor="Hot Leads"
                    className="mt-4"
                />
            }
        </CommonCard>
    )
}

export default EnhancedHotLeads